/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import './TaskListView.scss'
import React from 'react'
import r from '../../../util/Renderer'
import { BaseLayout, ListViewLayout } from 'ui-library/dist/external/layouts'
import { DataTable, DataTableColumn as TD, DataTableHeader as TH, DataTableRow as TR, NavigationDrawer, NormalButton, Pagination } from 'ui-library/dist/external/components'
import Date from '../../unit/Date'
import TaskAction from '../../../action/task'
import LocalArea from '../../templates/LocalArea'
import SearchField from '../../atoms/input/SearchField'
import Dropdown from '../../atoms/input/Dropdown'
import MultiCheckbox from '../../atoms/input/MultiCheckbox'
import Status from '../../../domain/model/task/Status.js'

function TaskListView(props) {
  const toolbar = { label: `タスク管理`, items: props.accountMenu }
  const pagination = props.pagination
  const searchFunction = params => {
    const pagination = props.pagination.merge({ page: params.page, per_page: params.per_page })
    TaskAction.onSearch(props.condition, pagination)
  }
  return (
    <div id="TaskList">
      <NavigationDrawer toolbar={toolbar} navigations={props.navigations} />

      <LocalArea>
        <MultiCheckbox name="status" checkList={Status.checkList} onChange={TaskAction.onEditSearchCondition} selection={props.condition.status} />
        <SearchField placeholder="タイトル" name="title" value={props.condition.title} onChange={e => TaskAction.onEditSearchCondition(e)} />
        <Dropdown
          raised
          className="condition__rooms"
          name="room_ids"
          value={props.condition.room_ids}
          options={props.room_options.options}
          isLoading={props.room_options.isLoading}
          isClearable={true}
          isMulti={true}
          searchable={true}
          onChange={e => TaskAction.onEditSearchCondition(e)}
        />
        <NormalButton type="dark" size="lg" onClick={() => searchFunction(props.pagination)}>
          検索
        </NormalButton>
      </LocalArea>

      <BaseLayout>
        <ListViewLayout>
          <DataTable
            style={{ marginBottom: '48px' }}
            headers={[
              <TH key={1} className="column--status">
                ステータス
              </TH>,
              <TH key={2} className="column--room_name">
                宿泊施設
              </TH>,
              <TH key={3} className="column--title">
                タイトル
              </TH>,
              <TH key={4} className="column--user_name">
                作成者
              </TH>,
              <TH key={5} className="column--updated_at">
                最終更新日時
              </TH>,
              <TH key={6} className="column--action" />
            ]}
            rows={r.renderIf(props.tasks)(
              props.tasks.map((task, index) => (
                <TR key={index}>
                  <TD>{task.status}</TD>
                  <TD>{task.room_name}</TD>
                  <TD>{task.title}</TD>
                  <TD>{task.user_name}</TD>
                  <TD>
                    <Date>{task.updated_at}</Date>
                  </TD>
                  <TD>
                    <NormalButton onClick={() => TaskAction.showDetail(task.reservation_id, task.id)}>編集</NormalButton>
                  </TD>
                </TR>
              ))
            )}
          />
        </ListViewLayout>
      </BaseLayout>
      <Pagination name="pagination" perPage={pagination.per_page} total={pagination.total} page={pagination.page} prev={e => searchFunction(e.value)} next={e => searchFunction(e.value)} />
    </div>
  )
}

export default TaskListView
